// Currency formatting utility for Indian Rupee
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₹0';
  
  // Indian number formatting (lakhs, crores)
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  
  return formatter.format(amount);
};

// Format without currency symbol (just the number)
export const formatNumber = (amount) => {
  if (amount === null || amount === undefined) return '0';
  
  return new Intl.NumberFormat('en-IN').format(amount);
};
